/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize PostVaccineAntiHbs List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PostVaccineAntiHbsListView';

export const mapStateToPropsPostVaccineAntiHbsList = mapStateToProps;
export const mapDispatchToPropsPostVaccineAntiHbsList = mapDispatchToProps;

export default connect(
  mapStateToPropsPostVaccineAntiHbsList,
  mapDispatchToPropsPostVaccineAntiHbsList
)(View);
